<template>
    <div class="bk">
    <nav id="navbar">
        <div class="d-flex justify-content-between align-items-center m-1 bg-white">
          <div @click="direct_home" class="hand">
            <div  class="d-flex justify-content align-items-center">
             <span class="topTitle">两棵树</span><img src="../assets/logo-ai.svg" class="logo">
            </div>
            
          </div>
          
        <div v-if="logined" class="btn" @click="relogin">退出</div>
   
      </div>
     
    </nav>
    <div class="colored_bk full-height pt-1" style="position:relative">     
        <router-view/>
    </div>
    
  </div>
   
</template>

<script>

import axios from 'axios';
// import AccountPageVue from './AccountPage.vue';
export default {
  data() {
    return {
      role:0,
      needLogin:false,
      router:'account',
      showqr:false,
      promotion_qr:null,
      logined:false
    };
  },
  components: {
 
    // AccountPageVue
  },
  mounted(){
   
    this.direct_home()
  },

  setup(){
    console.log('setup')
    
    var token=localStorage.getItem('sessionToken')
    axios.defaults.headers.common['X-Parse-Session-Token'] = token

 },
  methods: {
    direct_home(){
      var token=localStorage.getItem('sessionToken');
        this.role=localStorage.getItem('role');

          if(token==undefined || token==null ||token=='')
          {
            this.logined=false
            this.$router.push('/home')
            
            // this.needLogin=true
          }
          else
          {
            this.logined=true
            // this.$router.push('/index/user')
           
            // this.needLogin=false;
          }
    },
    displayQr(){
      this.showqr=true;
      this.getQr();
    },
    changeRouter(name){
      this.router=name;
      this.$router.push('/index/'+name)
    },
   
    relogin(){
      localStorage.setItem('sessionToken','');
      localStorage.setItem('role',undefined);
      this.logined=false;
      this.$router.push('/home')
      // this.needLogin=true;
      
    },
    
    openXHS(){
    //    const cookies = ipcRenderer.sendSync('open_login')
    //    console.log(cookies)
    },

    async getQr(){
      try{

        const response = await axios.get(this.domain+'xhs/get_promotion_qr');

        var data=response.data
        if(data.status=='Suc')
        {
            this.promotion_qr=data.qr           
        }
        else
        {
            console.error(data)
            
        }
      }
      catch(error)
      {
          console.error(data)
      }
     
     
    },

  }
};
</script>

<style scoped>


.topTitle{
    font-size: 0.3rem;
    font-style: normal;
    font-weight: 800;
}

.logo{
  height:0.4rem
}

#navbar {
 
  width: 100%;
  background-color: #ffffff;

  
}
.selectedFont{
  color: #3b64ff;

 
 
}
.unselectedFont{
  color: #262626;
}

.icon{
  width:0.3rem;
  height:0.3rem;
}
.gap{
  margin-left: 0.1rem;
}


</style>
